import ClientInfo from "../../../../components/clientInfo/clientInfo";
import React from "react";
import { useSelector } from "react-redux";

const ClientInfoTable = () => {
  const {
    clientInfo,
    clientVisits,
    clientSales,
    clientPastDues,
    clientMembershipTypes,
    clientProspectTypes,
    clientContactLogs,
    clientCharts,
    clientContracts,
    contractStatuses,
    contractFreezes,
    haveError,
    error,
    currentUser,
    contactsLoading,
    apiError
  } = useSelector((state) => state.clientProfileModule);
  return (
    <ClientInfo
      clientInfo={clientInfo.clientInfo}
      quickFacts={clientInfo.quickFacts}
      currentInfo={clientInfo.currentInformation}
      visitsData={clientVisits}
      salesData={clientSales}
      pastDuesData={clientPastDues}
      membershipTypesData={clientMembershipTypes}
      prospectTypesData={clientProspectTypes}
      contactLogs={clientContactLogs}
      chartData={clientCharts}
      clientContracts={clientContracts}
      contractStatuses={contractStatuses}
      contractFreezes={contractFreezes}
      haveError={haveError}
      error={error}
      isAdmin={currentUser.isAdmin}
      contactsLoading={contactsLoading}
      sourceType={clientInfo.sourceType}
      apiError={apiError}
    />
  );
};

export default ClientInfoTable;
